import * as React from 'react';
import { SVGProps } from 'react';

const SvgAsterixOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      d="m9.597 17.71-2.093-1.533 2.742-3.42L6 11.577l.826-2.476 4.068 1.563-.206-4.364h2.624l-.206 4.364L17.204 9.1 18 11.578l-4.216 1.15 2.742 3.45-2.123 1.532-2.388-3.685-2.418 3.685Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgAsterixOutlined;
